module.exports = WP_API_Settings;


//////////////////
// WEBPACK FOOTER
// external "WP_API_Settings"
// module id = 220
// module chunks = 0